import { t } from "i18next"

import { apiSlice } from "@/shared/api/api-slice"

import { type CancelSubscriptionRequest } from "../model/types"

export const deleteSubscriptionApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    cancelSubscription: builder.mutation<undefined, CancelSubscriptionRequest>({
      query: subscriptionId => ({
        url: `/api/v1/subscription/cancel/${subscriptionId}`,
        method: "DELETE"
      }),
      invalidatesTags: (_, error) => (error ? [] : ["Subscription", "Balance"])
    }),
    cancelPersonalSubscription: builder.mutation<undefined, undefined>({
      query: () => ({
        url: "/api/v1/subscription/personal/cancel",
        method: "DELETE"
      }),
      transformErrorResponse: response => {
        const messageMap: Record<number, string> = {
          404: t("personal-subscription-not-found", "No active subscription found"),
          502: t("personal-subscription-cancel-gateway-error", "Unable to cancel subscription. Please try again later")
        }
        const mapped = typeof response.status === "number" ? messageMap[response.status] : undefined
        if (mapped) {
          return { status: "CUSTOM_ERROR" as const, error: mapped }
        }
        return response
      },
      invalidatesTags: (_, error) => (error ? [] : ["PersonalSubscription", "Balance"])
    })
  })
})

export const { useCancelSubscriptionMutation, useCancelPersonalSubscriptionMutation } = deleteSubscriptionApi
